import { localStorageGetItem, localStorageSetItem } from "./localStorage";

const KEY_NAME = "user-token";
const PARTICIPANT_kEY_NAME = "participant-";
const CARAVANIST_KEY_NAME = "caravanist";

export const isTokenExpired = (token) => {
  if (!token) return true;
  const base64Url = token?.split(".")[1];
  if (!base64Url) return true;
  const base64 = base64Url?.replace(/-/g, "+")?.replace(/_/g, "/");
  const jsonPayload = decodeURIComponent(
    atob(base64)
      .split("")
      .map(function (c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join("")
  );
  const { exp } = JSON.parse(jsonPayload);
  const expired = Date.now() >= exp * 1000;
  return expired;
};

export const storageNewUserToken = (token, cpfNumber) => {
  console.log("storageNewUserToken", cpfNumber);
  const cpf = cpfNumber?.replace(/\D/g, "");
  localStorageSetItem(KEY_NAME + cpf, { token });
};

export const getTokenFromLocalStorage = (cpfNumber) => {
  const cpf = cpfNumber?.replace(/\D/g, "");

  const tokenFromLocal = localStorageGetItem(KEY_NAME + cpf);
  if (tokenFromLocal && tokenFromLocal.token) {
    console.log("getTokenFromLocalStorage", cpfNumber, tokenFromLocal.token);
    const isOk = !isTokenExpired(tokenFromLocal.token);
    if (isOk) {
      return tokenFromLocal.token;
    }
  }
  return null;
};

export const storageParticipant = (participantObj, cpfNumber) => {
  const cpf = cpfNumber?.replace(/\D/g, "");
  localStorageSetItem(PARTICIPANT_kEY_NAME + cpf, participantObj);
};
export const storageCaravanist = (participantObjResponse, caravanistUuid) => {
  let caravanist = {};
  const caravanists = participantObjResponse.caravanistParticipant;
  if (caravanists && Array.isArray(caravanists)) {
    if (caravanists.length === 1) {
      const obj = caravanists[0].caravanist;
      caravanist.name = obj.name;
      caravanist.uuid = obj.uuid;
      caravanist.photo = obj.photo;
    } else {
      const findCaravanist = caravanists.find(
        (item) => item.caravanist.uuid === caravanistUuid
      );
      if (findCaravanist) {
        const obj = findCaravanist.caravanist;
        caravanist.name = obj.name;
        caravanist.uuid = obj.uuid;
        caravanist.photo = obj.photo;
      }
    }
  }
  localStorageSetItem(CARAVANIST_KEY_NAME, caravanist);
};

export const getCaravanistFromLocalStorage = () => {
  const caravanist = localStorageGetItem(CARAVANIST_KEY_NAME);
  if (caravanist && caravanist.name) {
    return caravanist;
  }
  return null;
};

export const getParticipantFromLocalStorage = (cpfNumber) => {
  const cpf = cpfNumber?.replace(/\D/g, "");
  const participant = localStorageGetItem(PARTICIPANT_kEY_NAME + cpf);
  if (participant && participant.cpf) {
    return participant;
  }
  return null;
};

export const getCaravanistsListFromLocalStorage = (cpfNumber) => {
  const cpf = cpfNumber?.replace(/\D/g, "");
  const participant = getParticipantFromLocalStorage(cpf);
  if (participant && participant.caravanistParticipant) {
    const map = participant.caravanistParticipant.map((item) => {
      return item.caravanist;
    });
    return map;
  }
  return [];
};
